import React, { useContext } from 'react';
import { Loader } from 'lucide-react';
import styles from './LoadingIndicator.module.scss';

import { LanguageContext } from '../../context/LanguageContext';
// Import des traductions 
import translations from '../../utils/translations/LoadingIndicatorTranslations';

const LoadingIndicator = () => {

  // Utilisation du contexte de langue global
  const { language, changeLanguage } = useContext(LanguageContext);
  
  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;

  return (
  <div className={styles.loadingContainer}>
    <Loader className={styles.loader} size={48} strokeWidth={2} />
    <p>{t.loading}</p>
  </div>
  );
}

export default LoadingIndicator;